import { useState } from 'react'

interface PowerBIEmbedProps {
  url: string
  title: string
}

export default function PowerBIEmbed({ url, title }: Readonly<PowerBIEmbedProps>) {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const hasConfiguredUrl = Boolean(url.trim())

  const handleLoad = () => {
    setIsLoading(false)
  }

  const handleError = () => {
    setIsLoading(false)
    setHasError(true)
  }

  const showErrorState = hasError || !hasConfiguredUrl

  return (
    <div className="relative w-full h-full rounded-2xl border border-cbc-medium-blue/20 bg-cbc-dark-blue/45 backdrop-blur-xl shadow-cbc-dark overflow-hidden">
      {isLoading && hasConfiguredUrl && (
        <div className="absolute inset-0 flex items-center justify-center bg-cbc-navy/80 backdrop-blur-sm">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-cbc-primary"></div>
            <p className="mt-4 text-cbc-light-blue/80">Cargando dashboard...</p>
          </div>
        </div>
      )}

      {showErrorState && (
        <div className="absolute inset-0 flex items-center justify-center bg-cbc-navy/90 p-8 backdrop-blur-sm">
          <div className="text-center max-w-md">
            <svg className="w-16 h-16 text-cbc-primary mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className="text-lg font-semibold text-cbc-paper mb-2">
              {hasConfiguredUrl ? 'Error al cargar el dashboard' : 'Dashboard sin configurar'}
            </h3>
            <p className="text-sm text-cbc-light-blue/75 mb-4">
              {hasConfiguredUrl
                ? 'No se pudo cargar el contenido de Power BI. Por favor, verifica la URL o intenta más tarde.'
                : 'Falta la variable de entorno con la URL de Power BI para este dashboard.'}
            </p>
            {hasConfiguredUrl && (
              <button
                onClick={() => globalThis.location.reload()}
                className="px-4 py-2 bg-cbc-primary text-cbc-paper rounded-lg hover:bg-cbc-dark-blue transition-colors shadow-cbc"
              >
                Reintentar
              </button>
            )}
          </div>
        </div>
      )}

      {hasConfiguredUrl && (
        <iframe
          src={url}
          title={title}
          className="w-full h-full border-0 rounded-lg"
          allowFullScreen
          onLoad={handleLoad}
          onError={handleError}
        />
      )}
    </div>
  )
}
